/* eslint-disable arrow-body-style */
/* eslint-disable no-return-await */
import axiosApi from './inteceptor';
import utils from './utils';

const API_ADMIN = `${utils.svcUrl()}course`;

export default {
  createCourse: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  enrolllStudentInSegment: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/multi/enrolledInSegment`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  updateCourse: (id, data, userId) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/edit/${id}?userId=${userId}`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getCourses: (userId) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .get(`${API_ADMIN}/getall/creator/${userId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getProjects: (userId) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .get(`${API_ADMIN}/getall/projects/${userId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getLists: (courseId, sorting = 'desc') => {
    return new Promise((resolve, reject) => {
      axiosApi
        .get(`${API_ADMIN}/getAll/twitter/list?courseId=${courseId}&sorting=${sorting}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  replyTweet: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/replyTweet`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getPromo: (courseId) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .get(`${API_ADMIN}/get/promotion/${courseId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  addPromo: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/add/promotion`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  deletePromo: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/delete/promotion`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getNotifications: (courseId) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .get(`${API_ADMIN}/get/notification/${courseId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  cloneCourse: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/newCourse/fromExistingCourse`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  updateNotification: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/update/notification/${data.courseId}`, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getCourse: (courseId) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/${courseId}`, { url: 'https://example.com' })
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  deleteCourse: (courseId) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .delete(`${API_ADMIN}/${courseId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
};
